(() => {
	let e = window.Difrax?.sectionLifecycle;
	if (!e) return;
	let t = `[data-product-slider-recommendations]`,
		n = () => {
			let e = window.Shopify?.routes?.root || `/`;
			return e.endsWith(`/`) ? e : `${e}/`;
		},
		r = (e) => Math.max(160, e.clientWidth * 0.8),
		i = (e) => {
			let t = e.querySelector(`[data-product-slider-swiper]`);
			if (!t) return;
			let n = e.querySelector(`[data-product-slider-prev]`),
				r = e.querySelector(`[data-product-slider-next]`),
				i = Number(t.scrollLeft) || 0,
				a = Number(t.scrollWidth) || t.clientWidth,
				o = Math.max(0, a - t.clientWidth);
			n && (n.disabled = i <= 1), r && (r.disabled = o <= 1 || i >= o - 1);
		},
		a = (e) => {
			let t = e.querySelector(`[data-product-slider-swiper]`);
			if (!t || t.dataset.productSliderNativeInitialized === `true`) {
				i(e);
				return;
			}
			t.dataset.productSliderNativeInitialized = `true`;
			let n = (e) => {
				t.scrollBy({ left: e * r(t), behavior: `smooth` });
			};
			e
				.querySelector(`[data-product-slider-prev]`)
				?.addEventListener(`click`, () => n(-1)),
				e
					.querySelector(`[data-product-slider-next]`)
					?.addEventListener(`click`, () => n(1)),
				t.addEventListener(`scroll`, () => i(e), { passive: !0 }),
				t.addEventListener(`keydown`, (e) => {
					(e.key !== `ArrowLeft` && e.key !== `ArrowRight`) ||
						(e.preventDefault(), n(e.key === `ArrowRight` ? 1 : -1));
				}),
				i(e);
		},
		o = (e, t) => {
			let r = e.dataset.productSliderRecommendationsSectionId,
				i = e.dataset.productSliderRecommendationsProductId;
			if (!r || !i) return null;
			let a = new URL(window.location.href),
				o = new URL(a.href);
			o.pathname = `${n()}recommendations/products`;
			let s = [`preview_theme_id`, `pb`, `key`, `_fd`, `oseid`],
				c = new URLSearchParams();
			for (let e of s) {
				let t = a.searchParams.get(e);
				t && c.set(e, t);
			}
			(o.search = ``),
				c.forEach((e, t) => {
					o.searchParams.set(t, e);
				}),
				o.searchParams.set(`section_id`, r),
				o.searchParams.set(`product_id`, i);
			let l = e.dataset.productSliderRecommendationsLimit;
			l && o.searchParams.set(`limit`, l);
			let u = t || e.dataset.productSliderRecommendationsIntent;
			return u && o.searchParams.set(`intent`, u), o.toString();
		},
		s = (e, t) => {
			e.innerHTML = t.innerHTML;
			for (let { name: n, value: r } of Array.from(t.attributes))
				n === `id` || n === `class` || e.setAttribute(n, r);
			(e.className = t.className),
				e.removeAttribute(`data-product-slider-recommendations`);
		},
		c = async (e) => {
			let t = await fetch(e, {
				credentials: `same-origin`,
				headers: { Accept: `text/html` },
			});
			if (!t.ok) throw Error(`Unable to load recommendations`);
			return t.text();
		},
		l = (e, n) => {
			let r = new DOMParser().parseFromString(e, `text/html`),
				i = r.getElementById(`shopify-section-${n}`);
			if (i) {
				let e = i.querySelector(`[data-product-slider]`);
				if (e) return e;
			}
			let a = r.querySelector(t) || r.querySelector(`[data-product-slider]`);
			if (a) return a;
			let o = document.createElement(`div`);
			return (
				(o.innerHTML = e.trim()),
				o.querySelector(t) || o.querySelector(`[data-product-slider]`)
			);
		},
		u = async (t) => {
			if (t.dataset.productSliderRecommendationsLoaded === `true`) return;
			let n = t.dataset.productSliderRecommendationsSectionId;
			if (!n) return;
			t.dataset.productSliderRecommendationsLoaded = `true`;
			let r = [
				t.dataset.productSliderRecommendationsIntent,
				t.dataset.productSliderRecommendationsIntent === `related`
					? `complementary`
					: `related`,
			].filter(Boolean);
			try {
				let i = null;
				for (let e of r) {
					let r = o(t, e);
					if (!r) continue;
					let a = await c(r);
					if (((i = l(a, n)), i?.querySelector(`.product-slider__slide`)))
						break;
				}
				if (!i?.querySelector(`.product-slider__slide`)) {
					t.querySelector(
						`[data-product-slider-recommendations-loading]`,
					)?.removeAttribute(`data-product-slider-recommendations-loading`);
					return;
				}
				s(t, i),
					a(t),
					e.runAll?.(t, { reason: `product-slider:recommendations` });
			} catch (e) {
				t
					.querySelector(`[data-product-slider-recommendations-loading]`)
					?.removeAttribute(`data-product-slider-recommendations-loading`),
					console.warn(`Unable to load product slider recommendations`, e);
			}
		};
	e.register({
		name: `product-slider`,
		selector: `[data-product-slider]`,
		init(e) {
			if (e.matches(t) && !e.querySelector(`.product-slider__slide`)) {
				u(e);
				return;
			}
			a(e);
		},
		update(e) {
			i(e);
		},
	});
})();
